import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Clock } from 'lucide-react';
export function ContactInfo() {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="bg-gradient-to-br from-[#0066FF] to-[#06B6D4] rounded-2xl shadow-xl p-8 md:p-10 text-white h-full" data-id="element-67">
      <h3 className="text-2xl font-bold mb-8" data-id="element-68">Contact Information</h3>

      <div className="space-y-8" data-id="element-69">
        <div className="flex items-start gap-4" data-id="element-70">
          <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center shrink-0" data-id="element-71">
            <Phone size={24} data-id="element-72" />
          </div>
          <div data-id="element-73">
            <h4 className="font-bold text-lg mb-1" data-id="element-74">Phone Number</h4>
            <p className="text-blue-100" data-id="element-75">+977 1-4422334</p>
            <p className="text-blue-100 text-sm" data-id="element-76">+977 98-51234567</p>
          </div>
        </div>

        <div className="flex items-start gap-4" data-id="element-77">
          <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center shrink-0" data-id="element-78">
            <Mail size={24} data-id="element-79" />
          </div>
          <div data-id="element-80">
            <h4 className="font-bold text-lg mb-1" data-id="element-81">Email Address</h4>
            <p className="text-blue-100" data-id="element-82">info@himalayantrekking.com</p>
            <p className="text-blue-100 text-sm" data-id="element-83">
              support@himalayantrekking.com
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4" data-id="element-84">
          <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center shrink-0" data-id="element-85">
            <Clock size={24} data-id="element-86" />
          </div>
          <div data-id="element-87">
            <h4 className="font-bold text-lg mb-1" data-id="element-88">Opening Hours</h4>
            <p className="text-blue-100" data-id="element-89">Sunday - Friday</p>
            <p className="text-blue-100 font-semibold" data-id="element-90">9:00 AM - 6:00 PM</p>
            <p className="text-blue-100 text-sm mt-2" data-id="element-91">Saturday: Closed</p>
          </div>
        </div>

        <div className="pt-6 border-t border-white/20" data-id="element-92">
          <p className="text-blue-100 leading-relaxed" data-id="element-93">
            Our office is located in the heart of Thamel, Kathmandu. We're here
            to help you plan your perfect Himalayan adventure.
          </p>
        </div>
      </div>
    </motion.div>;
}